import { useState, useCallback } from 'react';
import * as herdsmanManagementAction from "../redux/store-sarang/herdsman/herdsman-management.store";

export const useLookupHerdsman = () => {
    const [herdsman, setHerdsman] = useState([]);
    const [herdsmanAll, setHerdsmanAll] = useState([]);
    const [herdsmanGv, setHerdsmanGv] = useState([]);

    const getLookupHerdsman = useCallback(async () => {
        try {
            const res = await herdsmanManagementAction.GetLookupHerdsman();
            if (res && res.content) {
                setHerdsman(res.content);
                return res.content;
            }
            return [];
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    const getLookupHerdsmanGV = useCallback(async () => {
        try {
            const res = await herdsmanManagementAction.GetLookupHerdsmanGV();
            if (res && res.content) {
                setHerdsmanGv(res.content);
                return res.content;
            }
            return [];
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    const getLookupHerdsmanAll = useCallback(async () => {
        try {
            const res = await herdsmanManagementAction.GetLookupHerdsman(false);
            if (res && res.content) {
                setHerdsmanAll(res.content);
                return res.content;
            }
            return [];
        } catch (err) {
            console.error(err);
            throw err;
        }
    }, []);

    return { herdsman, herdsmanAll, herdsmanGv, getLookupHerdsman, getLookupHerdsmanGV, getLookupHerdsmanAll };
};
